import React from 'react';
import {
    Typography,
    Divider,
    Button,
    Card,
} from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import ShareIcon from '@mui/icons-material/Share';
import CardMedia from '@mui/material/CardMedia';
import A8AdMyVision from '../../components/A8/A8AdMyVision';
import CATEGORY_IMAGE from '../../../static/biz-professional/japan-7144548_1280.jpeg';
import { useNavigate } from 'react-router-dom';
import GL_IMAGE from '../../../static/biz-professional/GalleryLambda-Slide-Structure.png';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';

interface ArticlePageProps {
    path: string;
}


const Article: React.FC<ArticlePageProps> = ({ path }) => {
    const handleCopyClick = () => {
        navigator.clipboard.writeText(path)
            .then(() => {
                console.log('Link copied to clipboard!');
            })
            .catch((err) => {
                console.error('Unable to copy link to clipboard', err);
            });
    };

    const navigate = useNavigate()
    const handleImageClick = (path: string) => {
        navigate(path);
        window.scrollTo(0, 0);
    };
    return (
        <div>
            <Box sx={{ mt: 7, mb: 12, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                <Card elevation={0} sx={{ maxWidth: 1000 }} style={{ margin: '0px', padding: '5px' }}>
                    <CardContent>
                        <Typography variant="h1" id="introduction" style={{ fontSize: '30px' }}>
                            第2回: 1スライドの中の基本構成を固めよう
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="body2" color="text.primary">
                            Published on 2024 Jan 15th <br />
                            5 min read  <br />
                            by Michelle
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            1つのスライドの中に含まれるべき要素は何か。スライドには企業の数だけデザインがありますが、
                            基本となる要素は何でしょうか。その要素さえ統一されていれば、見た目がどうであろうと、或いは
                            どの組織に所属してようと、的を得たスライドを作ることができるでしょう。また、それを理解することで、
                            素早くスライドを仕上げることにも役立つことでしょう。早速説明していきます。
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Button variant="text" size="small" endIcon={<ShareIcon />} style={{ color: 'black' }} onClick={handleCopyClick}>
                            Copy URL of this ariticle
                        </Button>
                    </CardContent>
                    <CardMedia
                        component="img"
                        height="500"
                        sx={{

                            objectFit: 'cover',
                            filter: 'grayscale(90%)',
                        }}
                        image={CATEGORY_IMAGE}
                        alt="image of the category"
                    />
                    <CardContent>
                        <Typography variant="body2" color="text.secondary">
                            1スライドの中の基本構成を固めよう
                        </Typography>
                    </CardContent>
                    <Divider style={{ margin: '20px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px', fontWeight: 'lighter' }}>Table of Contents</Typography>
                    </CardContent>
                    <ol>
                        <li><a href="#1">戦略コンサル各社に学ぶスライドの要素。</a></li>
                        <li><a href="#2">最小要素の纏め。</a></li>
                        <li><a href="#3">最後に一言。</a></li>
                    </ol>
                    <Divider id="1" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>戦略コンサル各社に学ぶスライドの要素。</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            1スライドに含まれるべき構成要素について、考えたことはあるでしょうか。戦略コンサルティングファームに入社すると
                            まずそのファーム内でグローバルで統一されたスライドデザインの研修があります。各ファームによってそのデザインこそ
                            バリエーションはあるのですが、構成要素としては各社に大きな差はありません。改めて、ケーススタディとして考えていきましょう。

                            <br />
                            <br />

                            <Card elevation={3}>
                                <CardContent>
                                    <Typography variant="h4" style={{ fontSize: '22px' }}>ケーススタディ - 1スライド内の構成要素 </Typography>
                                    <Typography paragraph style={{ fontSize: '20px' }}>
                                        <br />あなたは来週にチームとしてプレゼンテーションを控えています。あなたの部下としてのチームメンバーは10人いますが、
                                        メンバーには担当領域のスライドを作ってもらうことにしました。一方で、所属企業のパワーポイントのデザインにはそこまで厳しいルールは存在していません。
                                        そこでスライドのフォーマットのみ簡単に指定することにしました。その際に、最低限入っているべき要素として何を指定しますか
                                    </Typography>
                                </CardContent>
                            </Card>
                            <br />
                            <br />
                            みなさん、どうでしょう。あえてケーススタディとして出題してみましたが、その意図として一番大きなところは、下記の課題意識です。
                            外資系投資銀行や外資系戦略コンサルティングファームにおいてはスライド作成のデザインやそのパターンの厳格なルールを指定している場合が多く、
                            そうすることでグローバルでのスライドの統一化を図っていますが、多くの企業においてはその限りではありません。勿論、綺麗なスライドを作ることが目的では決してないので
                            フォーマットが統一されている必要は全くないのですが、構成要素レベルでは統一されている必要がある、というのが我々の見解です。
                            何故なら、プレゼンテーションの分かりやすさを飛躍的に向上させるからです。そろそろ、結局のことろ構成要素は何か、と疑問に思っていると思いますので
                            実例を見ていきましょう。

                            <br />
                            <br />

                            <CardMedia
                                component="img"
                                sx={{

                                    objectFit: 'cover',
                                }}
                                image={GL_IMAGE}
                                alt="image of the category"
                            />

                            <br />
                            その上でケーススタディの解答例です。
                            <br />
                            <br />
                            <Card elevation={3}>
                                <CardContent>
                                    <Typography variant="h4" style={{ fontSize: '22px' }}>解答例</Typography>
                                    <Typography paragraph style={{ fontSize: '20px' }}>
                                        <br /> プレゼンテーションにおける1スライド内の最小構成要素は、1. カテゴリ、2. トピック（論点）、3. トップメッセージ、4. ボディ
                                        の4点である。
                                    </Typography>
                                </CardContent>
                            </Card>
                            <br />
                            <br />

                            上記だけだと少し抽象的なので、解説していきます。<br />
                            1. カテゴリ: プレゼンテーション全体におけるスライドの位置付けを示すカテゴリ<br />
                            2. トピック（論点）: スライドのメッセージの大元である論点 <br />
                            3. トップメッセージ ー　ボディーに書いてある種々のファクトに対するあなたの解釈<br />
                            4. ボディー: 諸々のファクト<br /><br />

                            それぞれ、役割はなんでしょうか。まずカテゴリならびにトピックです。別記事の「イシューを洗い出そう。そして、構造化しよう。」で学んだように
                            プレゼンテーションでは答えるべきイシュー（問い）があります。それは論点とほぼ同義に使ってよいです。プレゼンテーションでは各々の論点に対して
                            答えを出していく作業ですから、スライドの中では、論点を明示する必要があります。だからこそ、（論点の属する）カテゴリと論点を記載すべきなのです。<br /><br />

                            もうお分かりの方も多いかと思いますが、その論点に対する答えが、トップメッセージです。言い換えると、設定したイシューに対する答えです。<br /><br />

                            最後に、ボディーの役割を。ボディーはトップメッセージを支えるファクト集です。<br /><br />

                            トップメッセージはボディーの解釈であり、つまり、ファクトとしての情報をスライドに詰め込んだ際、それらから言える結論としてのリスナーへのメッセージです。初級者はここまで覚えていれば十分です。
                            もしあなたが中級者でしたら、もう少し踏み込んだ解説を。トップメッセージは必ずしも、事実である必要はありません。何故なら、トップメッセージはあなたなりのボディー（ファクト）の解釈だからです。
                            あなたなりの面白い解釈を入れ込めるのかどうかが、腕の見せどころです。<br /><br />


                            <CardContent>
                                <TipsAndUpdatesIcon /> ここで、戦略コンサルティングファームであるBoston Consulting Groupの公開資料の公開資料のリンクを下記にご紹介します。P11ページを参考にしてみてください。
                                <blockquote>
                                    <Typography variant="body2" color="text.secondary">
                                        出典:METI <a href="https://www.meti.go.jp/meti_lib/report/2020FY/000410.pdf" target="_blank" rel="noopener noreferrer"> meti.go.jp </a> (スライドのp11, PDFのページはp12) - Boston Consulting Group
                                        なお、スライドのカテゴリとしては「継続的な案件形成」、トピックとしては「継続的な案件形成に〜」であることがみて取れますね。
                                    </Typography>
                                </blockquote>
                            </CardContent>

                            <CardContent>
                                <TipsAndUpdatesIcon /> さて、もう一つ例を見ていきましょう。次は、戦略コンサルティングファームであるRoland Bergerの公開資料です。リンクを下記にご紹介します。P30ページを参考にしてみてください。
                                ご覧いただいた通り、カテゴリは省略し、トピック（論点）のみ記載していますね。1スライドでは論点に対するメッセージを出すことが目的ですので、
                                必要に応じてカテゴリを省略し、論点のみを記載するのはよくあるパターンです。覚えておきましょう。
                                <blockquote>
                                    <Typography variant="body2" color="text.secondary">
                                        出典:METI <a href="https://rolandberger.tokyo/rolandberger-asset/uploads/2020/05/RB-COVID-19-STUDY_Mobility_summary.pdf" target="_blank" rel="noopener noreferrer"> meti.go.jp </a> (p30) - Roland Berger
                                    </Typography>
                                </blockquote>
                            </CardContent>

                        </Typography>
                    </CardContent>
                    <Divider id="2" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>最小要素の纏め。</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            下記を理解したと言えれば、本記事を理解したと言えるでしょう。プレゼンテーションにおける1スライド内の最小構成要素は下記の4点です。<br /><br />
                            1. トピック（省略可能）<br />
                            2. トピック（スライドが答えを出す論点）<br />
                            3. トップメッセージ（論点に対するあなたなりの解釈）<br />
                            4. ボディ（トップメッセージを支えるファクト）<br />

                        </Typography>
                    </CardContent>

                    <Divider id="3" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>最後に一言</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            スライドを作成する際、コンテンツを考えるよりもそのデザインを試行錯誤する時間って意外と長いですよね。
                            最小要素を意識することで、コンテンツに集中する時間を増やせるとともに
                            プレゼンテーションにわたって統一感を出すことができますし、何よりも伝えたいことがしっかりと伝わるプレゼンテーションになるでしょう。<br /><br />

                            また、昨今はインターネットにたくさんの雛形が落ちていますが、必ずしも最小要素を全て含むものばかりではありません。勿論、（アップルの）新商品発表会のような
                            プレゼン自体の見た目のインパクトやデザイン性が重要視されるプレゼンテーションも存在するので、デザインを重視したプレゼンが必要な場合もあります。一方で、
                            企業内でのプレゼンを中心に、多くのプレゼンではその最小要素を含む必要があるでしょう。<br /><br />

                            スライドのデザインが無限大にあるからこそ、そのファンダメンタルな構成要素を理解することは重要です。是非、日々のプレゼンで活用してみてください。
                        </Typography>
                    </CardContent>

                    <Divider style={{ margin: '20px 0' }} />
                    <CardContent>
                        <A8AdMyVision />
                    </CardContent>
                    <Button
                        variant="text"
                        size="small"
                        endIcon={<ShareIcon />}
                        style={{ color: 'black' }}
                        onClick={() => handleImageClick("/")}
                    >
                        他のプレゼンテーションスキルを学ぶ（記事一覧へ）
                    </Button>
                </Card>
            </Box>
        </div>
    );
};

export default Article;
